import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import appConfig from '../../config/env'
//import * as helpers from '../../helpers/helpers';
import { httpRequest } from '../../helpers/httpService';
import Loader from '../parts/Loader';

 
function ThankYou (){
    const [loading, setLoading] = useState(1);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const event_id = urlParams.get('e')
    const name = urlParams.get('d')
    const status = urlParams.get('status')
    const [event_data, setEvent] = useState({});
    const api_url = appConfig.apiUrl;
    
    useEffect(() => {
        //Mounted
        getEventData()
        window.scrollTo(0,0);
    }, []);

    function getEventData() {
        const url = api_url + '/public/events/'+event_id;

        httpRequest(url, "GET")
            .then((res) => {
                setEvent(res);
                setLoading(0)
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            });
    }

    return (
        <>
            <section className="faith h-100">
                <div className="container">
                    <div className="parent" style={{width: '100%', minHeight: '700px'}}>
                    <div className="container my-5">
                    <Loader isLoading={loading}/>
                        <div className="row d-flex justify-content-between">
                            {event_data.image_thumbnail &&
                            <div className="col-md-4 mb-5">
                                <img src={api_url + '/public/events/file/' + event_data.image_banner} className="img-fluid" />
                            </div>
                            }
                            <div className="col-md-7">
                                <h1 className="success-title mb-4">Hi, {name}!</h1>

                                {
                                status == 'success' &&
                                    <>
                                    <p className="success-text">You have successfully registered for <b>{event_data.title ? event_data.title : '[EVENT TITLE]'}.</b></p>
                                    <p className="success-text mb-5">Your Ticket information was sent to your email. Please check your junk or spam folder if you do not see them in your inbox.<br /> Thank You!</p>
                                    <Link to='/' className="btn btn-return py-3">Return to Events</Link>
                                    </>
                                }
                                {status == 'error' &&
                                    <>
                                    <p className="success-text mb-5">Whoops! there seems to be a problem with your registration. Please click the button below to try again. Thank you!</p>
                                    <Link to={`/registration/event/${event_id}`} className="btn btn-return py-3">Return to Registration</Link>
                                    </>
                                }
                                {status == 'pending' && //Over-the-counter payment method
                                    <>
                                    <p className="success-text">You way to go to complete your registration for <b>{event_data.title ? event_data.title : '[EVENT TITLE]'}</b>.</p>
                                    <p className="success-text mb-5">To complete your registration a payment instructions was sent to your email. Please check your junk or spam folder if you do not see them in your inbox.<br /> Thank You!</p>
                                    <Link to='/' className="btn btn-return py-3">Return to Events</Link>
                                    </>
                                }

                                {!status && <Link to='/' className="btn btn-return py-3">Return to Events</Link>}
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>

        </>
    )
}
 
export default ThankYou;